import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6heql54ieqv1pmm5810', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.3em] text-[#C0392B] uppercase mb-3">Get In Touch</p>
          <h2 className="text-4xl md:text-5xl font-light text-[#2D2D2D] mb-4">Contact Us</h2>
          <div className="w-12 h-0.5 bg-[#C0392B] mx-auto"></div>
        </div>

        <form 
          onSubmit={handleSubmit} 
          className="space-y-6 bg-[#FDF8F8] p-10 md:p-14 rounded-sm border border-[#F0E8E8]"
          data-readdy-form
          id="contact-form"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="name" className="block text-sm text-[#555555] mb-2 tracking-wide">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-[#E0D0D0] bg-white focus:border-[#C0392B] focus:outline-none transition-colors text-sm rounded-sm"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm text-[#555555] mb-2 tracking-wide">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-[#E0D0D0] bg-white focus:border-[#C0392B] focus:outline-none transition-colors text-sm rounded-sm"
              />
            </div>
          </div>

          <div>
            <label htmlFor="phone" className="block text-sm text-[#555555] mb-2 tracking-wide">
              Phone
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-[#E0D0D0] bg-white focus:border-[#C0392B] focus:outline-none transition-colors text-sm rounded-sm"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-sm text-[#555555] mb-2 tracking-wide">
              Comment
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              maxLength={500}
              rows={6}
              className="w-full px-4 py-3 border border-[#E0D0D0] bg-white focus:border-[#C0392B] focus:outline-none transition-colors resize-none text-sm rounded-sm"
            ></textarea>
            <p className="text-xs text-[#AAAAAA] mt-1">{formData.message.length}/500</p>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full md:w-auto px-12 py-4 bg-[#C0392B] text-white text-sm tracking-wider hover:bg-[#A93226] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer rounded-sm"
          >
            {isSubmitting ? '提交中...' : 'Send'}
          </button>

          {submitStatus === 'success' && (
            <div className="mt-4 p-4 bg-green-50 border border-green-200 text-green-800 text-sm rounded-sm">
              感谢您的留言！我们会尽快回复您。
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mt-4 p-4 bg-red-50 border border-red-200 text-red-800 text-sm rounded-sm">
              提交失败，请稍后重试。
            </div>
          )}
        </form>

      </div>
    </section>
  );
}